import React from 'react';
import clsx from 'clsx';
import { FingotiButton } from './Button';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';


const useStyles = makeStyles(theme => ({

    root: {
        border: '1px solid ' + theme.palette.greyFour.main,
        borderRadius: theme.spacing(1),
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(2) + 'px ' + theme.spacing(3) + 'px ',
        borderBottom: '1px solid ' + theme.palette.greyFour.main,
        background: theme.palette.greyFour.main,
    },
    icon: {
        fontSize: '2.25rem',
        fill: theme.palette.greyOne.main,
    },
    headerText: {
        marginLeft: theme.spacing(2),
    },
    title: {
        color: theme.palette.primary.main,
    },
    pricing: {
        padding: theme.spacing(3),
    },
    price: {
        color: theme.palette.secondary.main,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'space-evenly',
        padding: '0px ' + theme.spacing(2) + 'px',
        paddingBottom: theme.spacing(3)
    },
    button: {
        width: '45%',
    },
    vat: {
        color: theme.palette.greyThree.main,
        marginLeft: theme.spacing(1),
    },
    buttonLeft: {
        justifyContent: 'flex-start !important',
    }
}))

/**
 * Card for PAYG pricing
 * @param {Number} noOfPacks
 * @param {Number} pricePerPack
 * @param {Number} ripplesPerPack
 * @param {Function} handleSubscribe
 * @param {Function} handleLearnMore
 * @param {Boolean} business
 * @param {Boolean} showBuyNow - Default true
 * @param {Boolean} showLearnMore - Default true
 * @param {Boolean} calculator - Default false  
 * @returns {JSX.Element}
 */
export const PAYGCard = ({ noOfPacks, pricePerPack, ripplesPerPack, handleSubscribe, handleLearnMore,
    business, showBuyNow = true, showLearnMore = true, calculator = false }) => {

    const classes = useStyles();

    let packPrice = business ? parseFloat(pricePerPack) : parseFloat(pricePerPack * 1.2);

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <AccountBalanceWalletOutlinedIcon className={classes.icon} />
                <div className={classes.headerText}>
                    <Typography variant='h4' className={classes.title}>PAYG</Typography>
                    <Typography>Pay As You Go</Typography>
                </div>
            </div>
            <div className={classes.pricing}>
                {
                    calculator ?
                        <React.Fragment>
                            <Typography>
                                <span className={classes.price} style={{ fontSize: '2rem' }}>£{(noOfPacks * packPrice).toFixed(2)}</span> / month
                                <small className={classes.vat}>{business ? "ex VAT" : "inc VAT"}</small>
                            </Typography>
                            <Typography>
                                <span className={classes.price}>{(noOfPacks * ripplesPerPack).toLocaleString('en-GB')}</span> Ripples / month
                            </Typography>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <Typography>
                                <span className={classes.price} style={{ fontSize: '2rem' }}>£{packPrice.toFixed(2)}</span> / 5,000 Ripples
                                <small className={classes.vat}>{business ? "ex VAT" : "inc VAT"}</small>
                            </Typography>
                            <Typography>
                                <span className={classes.price}>£{(packPrice / 5000).toFixed(5)}</span> / Ripple
                                <small className={classes.vat}>{business ? "ex VAT" : "inc VAT"}</small>
                            </Typography>
                        </React.Fragment>
                }
            </div>
            <div className={clsx(classes.buttons, !showBuyNow && classes.buttonLeft)}>
                {
                    showBuyNow &&
                    <FingotiButton
                        light
                        color={"primary"}
                        onClick={handleSubscribe}
                        className={classes.button}
                    >
                        Buy now
                    </FingotiButton>
                }
                {
                    showLearnMore &&
                    <FingotiButton
                        light
                        onClick={handleLearnMore}
                        className={classes.button}
                    >
                        Learn more
                    </FingotiButton>
                }
            </div>
        </div>
    )

}